export default "__VITE_ASSET__CvTLaeFZ__"